module.exports = __webpack_public_path__ + "img/tomatsauce_new.1bf2695a.jpg";